import { BookACall } from "../sections/waq/home/BookACall";
import { CaseStudies } from "../sections/waq/home/CaseStudies";
import { EngagementModels } from "../sections/waq/home/EngagementModels";
import { Faq } from "../sections/waq/home/Faq";
import { Hero } from "../sections/waq/home/Hero";
import { Industries } from "../sections/waq/home/Industries";
import { MaturityCheck } from "../sections/waq/home/MaturityCheck";
import { TalentBand } from "../sections/waq/home/TalentBand";
import { TalentSplash } from "../sections/waq/home/TalentSplash";
import { DarkCanvas } from "../ui/waq/DarkCanvas";

export function Home() {

  return (
    <main id="main">
      {/* One navy canvas for the consecutive dark run: hero, engagement models
          and case studies, so the glows bleed across boundaries. */}
      <DarkCanvas>
        <Hero />
        <EngagementModels />
        <CaseStudies />
      </DarkCanvas>

      {/* Dark -> light handoff: the 140px gradient rides on this section. */}
      <Industries />
      {/* QA Talent: people rather than an engagement. Compact, light. */}
      <TalentBand />
      {/* Light-on-light from here: each section opens with a faded hairline. */}
      <MaturityCheck />
      <Faq />
      <BookACall />

      {/* The QA Talent offer, once per visit, a few seconds in. Client-only. */}
      <TalentSplash />
    </main>
  );
}
